import axios from "axios";
import BASE_API_URL from "../api/api";
import { store } from "../redux/store";
import { logoutSuccess } from "../redux/authRedux";
import Swal from "sweetalert2";

// const url = "http://192.168.1.33:4000/api/";
const url = BASE_API_URL;
const storeToken = store.getState().auth?.user?.token;
console.log("storeToken", storeToken);

const apiInstance = axios.create({
  baseURL: url,
  headers: {
    Authorization: `Bearer ${storeToken}`,
    "Content-Type": "application/json",
  },
});

apiInstance.interceptors.request.use(
  (config) => {
    // Dynamically fetch from localStorage as a fallback, ensuring the token is always up-to-date
    const currentToken = store.getState().auth?.user?.token || localStorage.getItem("token");
    if (currentToken) {
      config.headers["Authorization"] = `Bearer ${currentToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiInstance.interceptors.response.use(
  (response) => {
    console.log("Axios Logs", response);
    return response;
  },
  (error) => {
    console.log("Axios erros", error);
    if (error.response && error.response.status === 401) {
      Swal.fire({
        title: "Please Login Again",
        text: "Session Expired",
        icon: "warning",
        confirmButtonText: "OK",
      }).then((result) => {
        if (
          result.isConfirmed ||
          result.dismiss === Swal.DismissReason.backdrop
        ) {
          store.dispatch(logoutSuccess());
        }
      });
    }
    return Promise.reject(error);
  },
);

export default apiInstance;
